import React from "react";
import { SiWeightsandbiases } from "react-icons/si";
import { MdFitnessCenter, MdElectricCar, MdEditDocument,MdBadge } from "react-icons/md";
import { FaSailboat } from "react-icons/fa6";
import { FaLongArrowAltRight } from "react-icons/fa";
import "./Specialities.css"

const Specialities = () => {
  const specialities = [
    {
      id: 1,
      title: "تسويق العقارات",
      icon: <SiWeightsandbiases />,
      subText: "ألقي نظرة"
    },
    {
      id: 2,
      title: "الوساطة العقارية",
      icon: <MdBadge />,
      subText: "أحسن"
    },
    {
      id: 3,
      title: "استشارات عقارية",
      icon: <MdElectricCar />,
      subText: "استشارية "
    },
    {
      id: 4,
      title: "توثيق العقد",
      icon: <MdEditDocument />,
      subText: "منهجي"
    },
    {
      id: 5,
      title: "خدمة مزادات العقارات",
      icon: <FaSailboat />,
      subText: "منهجي"
    },
  ];
  return (
    <>
      <section id="ourSpecialities">
        <h1>خدماتنا</h1>
        <div className="specialities_container">
          {
            specialities.map(element=>{
              return(
                <div className="card" key={element.id}>
                    <div className="icon">{element.icon}</div>
                    <div className="title_text">{element.title}</div>
                    <div className="subtitle_text">{element.subText} <FaLongArrowAltRight/></div>
                </div>
              )
            })
          }
        </div>
      </section>
    </>
  );
};

export default Specialities;
